// extracted by mini-css-extract-plugin
export default {"contentinfo":"Footer_contentinfo__Qt+ew","colophon":"Footer_colophon__o-Fvt"};